'use client'

// The camera at the glass of his vending machine while its close view is open (components/ui/VendingHud.jsx). It
// eases there from wherever the walker left it, the way PinoCam's spring eases, and holds; the walker stands down
// while it is mounted (mainScene's fpEnabled) and picks up where it was when it closes.

import { useMemo, useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three/webgpu'
import { vendingShot, vendingSpot } from '../../../lib/world/vending'

const SPRING = 4

export function VendingCam() {
  const { camera } = useThree()
  const shot = useMemo(() => vendingShot(vendingSpot()), [])
  const look = useRef(null)
  const eye = useMemo(() => (shot ? new THREE.Vector3(...shot.eye) : null), [shot])
  const target = useMemo(() => (shot ? new THREE.Vector3(...shot.target) : null), [shot])

  useFrame((_, dt) => {
    if (!eye) return
    if (!look.current) {
      // from where the camera is looking now, so the turn is eased too
      look.current = new THREE.Vector3()
      camera.getWorldDirection(look.current)
      look.current.multiplyScalar(4).add(camera.position)
    }
    const k = 1 - Math.exp(-SPRING * Math.min(dt, 0.1))
    camera.position.lerp(eye, k)
    look.current.lerp(target, k)
    camera.lookAt(look.current)
  })
  return null
}
